<template>
    <div class="displayContent">
        <div class="fruits">
            <div class="fruitRow">
                <Button @click="changeTheme('banana')"
                    :class="['fruitButton', { isActive: preferences.scheme === 'banana' }]"
                    appearance="secondary">
                    <div class="fruit banana"></div>
                </Button>
                <Button @click="changeTheme('avocado')"
                    :class="['fruitButton', { isActive: preferences.scheme === 'avocado' }]"
                    appearance="secondary">
                    <div class="fruit avocado"></div>
                </Button>
            </div>
            <div class="fruitRow">
                <Button @click="changeTheme('orange')"
                    :class="['fruitButton', { isActive: preferences.scheme === 'orange' }]"
                    appearance="secondary">
                    <div class="fruit orange"></div>
                </Button>
                <Button @click="changeTheme('strawberry')"
                    :class="['fruitButton', { isActive: preferences.scheme === 'strawberry' }]"
                    appearance="secondary">
                    <div class="fruit strawberry"></div>
                </Button>
            </div>
        </div>
        <SetTheme class="setTheme"/>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    import SetTheme from '@/components/templates/SetTheme'

    export default {
        name: 'Display',
        components: {
            SetTheme
        },
        props: {
            content: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                color: '',
            }
        },
        methods: {
            ...mapActions('users',['setPreferredScheme']),

            changeTheme(color) {
                this.setPreferredScheme(color)
                this.changeColorScheme(color)
            },

            changeColorScheme(color) {
                var root = document.querySelector(':root')
                var primaryColor
                var primaryAscent
                var primaryDescent

                if(color === 'avocado') {
                    primaryColor = '#70ff90'
                    primaryAscent = '#88f7a2'
                    primaryDescent = '#46c262'
                } else if(color === 'orange') {
                    primaryColor = '#fa732a'
                    primaryAscent = '#ff8542'
                    primaryDescent = '#cf5411'
                } else if(color === 'strawberry') {
                    primaryColor = '#ed2b45'
                    primaryAscent = '#f55369'
                    primaryDescent = '#bd132a'
                } else {
                    primaryColor = '#ffbf00'
                    primaryAscent = '#ffda6c'
                    primaryDescent = '#db9600'
                }
            
                root.style.setProperty('--color-primary-500', primaryColor)
                root.style.setProperty('--color-primary-300', primaryDescent)
                root.style.setProperty('--color-primary-700', primaryAscent)
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/variables';

    .fruits {
        display: flex;
    }

    .fruitRow {
        display: flex;
        margin: 0 0.75rem 2rem 0;
    }

    .fruitButton {
        margin-right: 0.75rem;

        &:last-of-type {
            margin: 0;
        }
    }

    .fruit {
        width: 4rem;
        height: 4rem;
    }

    .avocado {
        content: var(--avocado);
    }

    .banana {
        content: var(--banana);
    }

    .orange {
        content: var(--orange);
    }

    .strawberry {
        content: var(--strawberry);
    }

    .isActive {
        box-shadow: 0 0 0 0.3rem var(--color-primary-500) !important;
    }
</style>